module.exports = __webpack_public_path__ + "static/media/onlineipe-01.7500021e.jpg";